import styled from 'styled-components/macro'
import { Breakpoints } from 'styles/breakpoints'

export const SubInfoStyled = styled.div`
position: relative;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;
  margin-bottom: 10px;
`

export const Title = styled.p`
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 14px;
  color: #F8FAFC;

  @media (max-width: ${Breakpoints.md}) {
    font-size: 14px;
  }
`

export const Content = styled.p`
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 14px;
  color: #F8FAFC;
  text-transform: uppercase;

  @media (max-width: ${Breakpoints.md}) {
    font-size: 20px;
  }
`